
type RegisterHeaderProps = {
    heading: string
    description: string
}


const RegisterHeader = (props: RegisterHeaderProps) => {

    return (
        <div>
            <header className="text-center">
                <h2 className="text-secondary text-lg lg:text-xl font-semibold">
                    {props.heading}
                </h2>
                <p className="text-xs md:text-sm text-[#7A7773]">
                    {props.description}
                </p>
            </header>
        </div>
    )
}

export default RegisterHeader